import ApiRequestBuilder from '../ApiService/Request/ApiRequestBuilder';


const API_PATH_CONFIG_BASE = '/config';
const API_PATH_CONFIG_GEO = `${API_PATH_CONFIG_BASE}/geo`;
const API_PATH_CONFIG_GLOBAL = `${API_PATH_CONFIG_BASE}/global`;
const API_PATH_CONFIG_USER = `${API_PATH_CONFIG_BASE}/user`;


class ConfigService {

    /**
     * @type {ApiService}
     */
    apiService;


    /**
     * @param apiService {ApiService}
     */
    constructor(apiService) {

        this.apiService = apiService;
    }


    /**
     * @return {Promise<ApiResponse>}
     */
    async loadGlobalConfig() {

        const globalConfigRequest = ApiRequestBuilder.get(API_PATH_CONFIG_GLOBAL)
            .json()
            .withToken()
            .build();

        return this.apiService.executeOrFail(globalConfigRequest, 'Error loading global config');
    }


    /**
     * @return {Promise<ApiResponse>}
     */
    async loadGeoConfig() {

        const geoConfigRequest = ApiRequestBuilder.get(API_PATH_CONFIG_GEO)
            .json()
            .build();

        return this.apiService.executeOrFail(geoConfigRequest, 'Error loading geo config');
    }


    /**
     * @return {Promise<object>}
     */
    async loadUserConfig() {

        const userConfigRequest = ApiRequestBuilder.get(API_PATH_CONFIG_USER)
            .json()
            .withToken()
            .build();

        return this.apiService.executeOrFail(userConfigRequest, 'Error loading user config');
    }


    /**
     * @param updatedUserConfig {object} Updated user config
     * @return {Promise<ApiResponse>} No content/204 response if successful
     */
    async updateUserConfig(updatedUserConfig) {

        const updateUserConfigRequest = ApiRequestBuilder.put(API_PATH_CONFIG_USER)
            .json()
            .withToken()
            .body(updatedUserConfig)
            .build();

        return this.apiService.execute(updateUserConfigRequest);
    }
}

export default ConfigService;
